<div class="overlay"></div>

@if (userInvite && userInvite.inviteStatus === 1) {
    @if (userInvite.isShijiInvite || supplier) {
        <div class="card" [ngClass]="{ largeCard: currentStep === 1 }">
            <app-menu class="languageMenu" #languageAppMenu [positioning]="['bottom', 'left']">
                <button class="button small transparent onlyIcon" menuActivator>
                    <i class="icon fas fa-fw fa-language"></i>
                </button>

                <ul class="menuList">
                    @for (language of supportedLanguages; track language.languageCode) {
                        <li
                            class="menuItem"
                            [ngClass]="{ active: language.languageCode === currentLanguage }"
                            (click)="changeLanguage(language)"
                        >
                            <img [src]="IMAGES.TRANSPARENT_GIF" class="flag" [ngClass]="'flag-' + language.flag" alt="flag" />
                            {{ language.label }}
                        </li>
                    }
                </ul>
            </app-menu>

            <header>
                <div class="welcomeContainer">
                    @if (supplier && supplier.logo) {
                        <div class="logoContainer">
                            <img class="logo" [src]="supplier.logo" alt="{{ supplier.companyName }}" />
                        </div>
                    }
                    <div class="welcome">
                        <h1>{{ 'users.onboarding.welcome' | translate: { userEmail: userEmail } }}</h1>
                        @if (supplier && supplier.companyName) {
                            <h2>{{ 'users.onboarding.welcome2' | translate: { supplier: supplier.companyName } }}</h2>
                        }
                    </div>
                </div>
            </header>

            <app-form-error [parentForm]="registrationForm" />
            @if (currentStep === 0) {
                <form action="" [formGroup]="registrationForm">
                    <div class="inputLine">
                        <label for="firstName">{{ 'users.onboarding.form.firstName' | translate }}</label>
                        <app-form-error [parentForm]="registrationForm" [controlPath]="'firstName'" />
                        <input type="text" id="firstName" formControlName="firstName" trimInput />
                    </div>

                    <div class="inputLine">
                        <label for="lastName">{{ 'users.onboarding.form.lastName' | translate }}</label>
                        <app-form-error [parentForm]="registrationForm" [controlPath]="'lastName'" />
                        <input type="text" id="lastName" formControlName="lastName" trimInput />
                    </div>

                    @if (!userInvite.identityCreatedExternal) {
                        <div class="inputLine">
                            <label for="password">{{ 'users.onboarding.form.password' | translate }}</label>
                            <app-form-error [parentForm]="registrationForm" [controlPath]="'password'" />
                            <app-password-input [id]="'password'" formControlName="password" />
                        </div>
                        <div class="inputLine confirmPasswordContainer">
                            <label for="confirmPassword">{{ 'users.onboarding.form.confirmPassword' | translate }}</label>
                            <app-form-error [parentForm]="registrationForm" [controlPath]="'confirmPassword'" />
                            <app-password-input [showHints]="false" [id]="'confirmPassword'" formControlName="confirmPassword" />
                        </div>
                    }
                </form>

                <footer>
                    <button type="button" class="button primary" [ngClass]="{ disabled: !registrationForm.valid }" (click)="nextStep()">
                        {{ 'users.onboarding.form.next' | translate }}
                        &nbsp;
                        <i class="fat fa-chevron-right"></i>
                    </button>
                </footer>
            }

            <!-- PART TWO -->
            @if (currentStep === 1) {
                <form class="termsAndConditionsContainer" [formGroup]="termsAndConditionsForm">
                    <div
                        class="termsAndConditionsDocument"
                        [innerHtml]="termsAndConditionsDocumentHTML"
                        #termsAndConditionsDocumentElement
                    ></div>
                    <i class="fal fa-download"></i>
                    <a class="downloadLink" (click)="downloadTCCopy()">
                        {{ 'users.onboarding.form.downloadDocument' | translate }}
                    </a>
                    <app-form-error [parentForm]="termsAndConditionsForm" [controlPath]="'acceptTermsAndConditions'" />
                    <div
                        class="inputWrapper acceptTermsAndConditionsCheckbox"
                        title="{{ !wasScrollOnBottom ? ('users.onboarding.form.pleaseReadTermsAndConditions' | translate) : '' }}"
                    >
                        <input
                            type="checkbox"
                            formControlName="acceptTermsAndConditions"
                            [ngClass]="{ disabled: !wasScrollOnBottom }"
                            id="acceptTermsAndConditions"
                        />
                        &nbsp;
                        <label class="termsAndConditionsLabel" for="acceptTermsAndConditions">{{
                            'users.onboarding.form.acceptTermsAndConditions' | translate
                        }}</label>
                    </div>
                </form>

                <footer class="stepTwoFooter">
                    <button type="button" class="button" (click)="previousStep()">
                        <i class="fat fa-chevron-left"></i>
                        &nbsp;
                        {{ 'users.onboarding.form.previous' | translate }}
                    </button>

                    <button
                        type="button"
                        class="button primary"
                        [ngClass]="{ disabled: !termsAndConditionsForm.get('acceptTermsAndConditions')?.value }"
                        (click)="finishRegistration()"
                    >
                        {{ 'users.onboarding.form.create' | translate }}
                    </button>
                </footer>
            }
        </div>
    }
} @else {
    @if (userInvite && userInvite.inviteStatus !== 1) {
        <div class="card">
            <app-menu class="languageMenu" #languageAppMenu [positioning]="['bottom', 'left']">
                <button class="button small transparent onlyIcon" menuActivator><i class="icon fas fa-fw fa-language"></i></button>

                <ul class="menuList">
                    @for (language of supportedLanguages; track language.languageCode) {
                        <li
                            class="menuItem"
                            [ngClass]="{ active: language.languageCode === currentLanguage }"
                            (click)="changeLanguage(language)"
                        >
                            <img [src]="IMAGES.TRANSPARENT_GIF" class="flag" [ngClass]="'flag-' + language.flag" alt="flag" />
                            {{ language.label }}
                        </li>
                    }
                </ul>
            </app-menu>
            <div class="expiredInviteContainer">
                @if (supplier && supplier.logo) {
                    <div class="imageWrapper">
                        <img alt="logo" [src]="supplier.logo" class="logo" />
                    </div>
                }
                <div class="invalidMessage">
                    <span>{{ 'users.onboarding.form.invitationExpiredText' | translate }}</span>
                    <span>{{ 'users.onboarding.form.contactAdministratorText' | translate }}</span>
                </div>
            </div>
        </div>
    }
}
